<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-awsMoqSet',
  components: {
    PageTable,
  },
}
</script>